import { ChangeDetectorRef, Component, computed, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import {
	faAngleRight,
	faList,
	faSortDown,
	faSortUp,
	faSquare,
	faInfoCircle,
	faSquareCheck,
	fa1,
	fa2,
	fa3,
	faTable,
	faSquareFull,
	faTableCellsLarge,
	faCoffee,
	faEye,
	faOutdent,
	faMattressPillow,
	faCheckSquare,
	faGear,
	faWrench,
	faCheck,
	faGripVertical,
	faSearch,
} from '@fortawesome/free-solid-svg-icons';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { accordionGroupInterface, accordionGroupOrder, accordionInterface } from 'src/app/util/interfaces/accordion';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { HomePageService } from './data/home-page.service';
import { PermissionService } from 'src/app/util/services/permission/permission.service';
import { statusInterface } from 'src/app/util/interfaces/statusInterface';
import { forkJoin, Subscription } from 'rxjs';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { MspTableService } from 'src/app/page_component_item/msp-table/service/msp-table.service';
import { OutOfOfficeService } from 'src/app/components/menu-profile/components/out-of-office/service/out-of-office.service';
import { BehalfOfService } from 'src/app/services/behalfOf/behalf-of.service';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { searchRequestsInterface } from 'src/app/util/interfaces/search';
import { DateRangePickerComponent } from 'src/app/page_component_item/date-range-picker/date-range-picker.component';
import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';
import { DateService } from 'src/app/services/date/date.service';
import { ModalComponent } from 'src/app/page_component_item/modal/modal.component';
import { LoadingNotificationService } from 'src/app/services/loading-notification/loading-notification.service';
import { ExcelService } from 'src/app/services/excel/excel.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { CommonModule } from '@angular/common';
import { SvgGearsModule } from 'src/app/page_component_item/svg-gears/svg-gears.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { InputWithAutocompleteModule } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.module';
import { CheckboxModule } from 'src/app/page_component_item/checkbox/checkbox.module';
import { FormsModule } from '@angular/forms';
import { DotBounceLoadingEffectModule } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.module';
import { GenericFormGenModule } from 'src/app/page_component_item/generic-form-gen/generic-form-gen.module';
import { KnowledgeArchiveComponent } from 'src/app/page_component/knowledge-archive/knowledge-archive.component';
import { PaginationCounterComponent } from 'src/app/page_component_item/pagination-counter/pagination-counter.component';
import { CustomAccordionComponent } from 'src/app/components/menu-profile/components/custom-accordion/custom-accordion.component';
import { RequestSatisfactionComponent } from 'src/app/page_component/request-satisfaction/request-satisfaction.component';
import { SelfservicePageComponent } from '../selfservice-page/selfservice-page.component';
import { MspTableRmkComponent } from 'src/app/page_component_item/msp-table-rmk/msp-table-rmk.component';
import { Timer } from 'src/app/util/classes/timer/timer.class';
import { TooltipDirective } from 'src/app/util/directives/tooltip/tooltip.directive';
import { accordionType } from './data/home-page.type';
import { ProfileSignal } from 'src/app/services/profile/profile.signal';

@Component({
	standalone: true,
	imports: [
		CommonModule,
		RouterModule,
		SvgGearsModule,
		DateRangePickerComponent,
		FontAwesomeModule,
		InputWithAutocompleteModule,
		CheckboxModule,
		ModalComponent,
		FormsModule,
		DotBounceLoadingEffectModule,
		GenericFormGenModule,
		PaginationCounterComponent,
		KnowledgeArchiveComponent,
		CustomAccordionComponent,
		RequestSatisfactionComponent,
		SelfservicePageComponent,
		MspTableRmkComponent,
		TooltipDirective,
	],
	selector: 'app-home-page-rework',
	templateUrl: './home-page.component.html',
	styleUrls: ['./home-page.component.scss', '../../../page_component_item/msp-cmdb-table-like/msp-cmdb-table-like.component.scss'],
})
export class HomePageComponent implements OnInit {
	private readonly HomePageService = inject(HomePageService);
	private readonly LabelsService = inject(LabelsService);
	private readonly ProfileService = inject(ProfileService);
	private readonly Router = inject(Router);
	private readonly ActivatedRoute = inject(ActivatedRoute);
	private readonly MspTableService = inject(MspTableService);
	private readonly BehalfOfService = inject(BehalfOfService);
	private readonly cdr = inject(ChangeDetectorRef);
	private readonly DateService = inject(DateService);
	private readonly ExcelService = inject(ExcelService);
	private readonly LoadingNotificationService = inject(LoadingNotificationService);

	protected readonly profileSignal = inject(ProfileSignal);

	public readonly NotificationService = inject(NotificationService);
	public readonly PermissionService = inject(PermissionService);

	icons = {
		faList: faList,
		faAngleRight: faAngleRight,
		faSearch: faSearch,
		faInfoCircle: faInfoCircle,
		fa1: fa1,
		fa2: fa2,
		fa3: fa3,
		faTable: faTable,
		faSquareFull: faSquareFull,
		faSquare: faSquare,
		faSquareCheck: faSquareCheck,
		faTableCellsLarge: faTableCellsLarge,
		faSortDown: faSortDown,
		faSortUp: faSortUp,
		faCoffee: faCoffee,
		faEye: faEye,
		faOutdent: faOutdent,
		faMattressPillow: faMattressPillow,
		faCheckSquare: faCheckSquare,
		faGear: faGear,
		faWrench: faWrench,
		faCheck: faCheck,
		faGripVertical: faGripVertical,
	};

	iconsForStatus = {
		'Waiting for Approval': 'faTriangleExclamation lbl_geral_chamado_aguardando_aprovacao',
		vip: 'faTriangleExclamation lbl_geral_chamado_usuario_vip',
		escalation_level: 'faTriangleExclamation lbl_geral_nivel_de_escalada LEVEL',
	};

	labels: LabelsInterface = {
		lbl_chamado_abrir: 'Open request',
		lbl_selecione_uma_opcao: 'Select an option beside',
		lbl_geral_inicio: 'Start',
		lbl_chamado: 'Request',
		lbl_geral_risco_baixo: 'Low risk',
		lbl_geral_risco_medio: 'Medium risk',
		lbl_geral_risco_alto: 'High risk',
		lbl_geral_tipo: 'Type',
		lbl_chamado_nao_classificado: 'Request not classified',
		lbl_geral_descricao: 'Description',
		lbl_edocs_carregando: 'Loading',
		lbl_geral_status: 'Status',
		lbl_chat_voce_nao_possui_atendimento_hoje: 'You do not have service today',
		lbl_geral_ordenado_por: 'Order by',
		lbl_geral_data_limite2: 'Limit date',
		lbl_chamado_data_abertura: 'Open date',
		lbl_an_errour_occour: 'An error occour, please, try again',
		lbl_nao_classificado: 'Not classified',
		lbl_geral_pendencias: 'My',
		lbl_geral_pendencias_grupo: 'Solution Areas Pending Activities',
		lbl_checklist: 'Checklist',
		lbl_geral_pendencias_pessoais: 'Personal Pending Activities',
		lbl_geral_pendencias_grupo_analista: 'Issues of the entire Independent Analyst group',
		lbl_geral_pendencias_analista: 'Analyst pending',
		lbl_geral_chamado_checklist: 'Checklists on my behalf ready to run',
		lbl_rep_custom_id_36: '',
		lbl_chamado_solicitacao: '',
		lbl_geral_depto: '',
		lbl_geral_site: '',
		lbl_geral_localidade: '',
		lbl_geral_competencia: '',
		lbl_asset_category: '',
		lbl_geral_topico: '',
		lbl_grupo: '',
		lbl_geral_analista: '',
		lbl_geral_usuario: '',
		lbl_geral_registrado_por: '',
		lbl_avaliacoes_pendentes_request: '',
		lbl_geral_colunas: '',
		lbl_itens_da_listagem: '',
		lbl_sem_atendimentos_na_fila: '',
		lbl_geral_chamado: '',
		lbl_chamados_relacionados_usuario: '',
		lbl_lista_chamados_personalizada: '',
		lbl_chamado_tarefas: 'Tasks',
		lbl_rep_custom_id_32: 'Requests List',
		lbl_kb_criar: 'Create',
		lbl_chamado_tarefa_encaminhada_vc: '',
		lbl_cis_ativos: 'Active CIs',
		lbl_cmdb_cis_relacionados: 'Related CIs',
		lbl_exibe_ativos_usuario_final: 'Displays the assets that belong to the end user',
		lbl_responsabilidade_delegada: '',
		lbl_ausencia_temporaria_delegada: '',
		lbl_ativar_visao_usuario: '',
		lbl_iac_min_char_search: '',
		lbl_geral_buscar: '',
		lbl_erro_0113: 'ERROR: Application Error',
		lbl_geral_selecione: 'Select',
		lbl_geral_pesquisa_chamados: 'Request Search',
		lbl_geral_nao: 'No',
		lbl_geral_sim: 'Yes',
		lbl_geral_pesquisa: 'Search',
		lbl_chamado_pesquisa_avancada: 'Advanced Ticket Search',
		lbl_chamado_campo: 'Ticket Field',
		lbl_bulletin_actions: '',
		lbl_geral_opcoes_de_coluna: '',
		lbl_geral_salvar: '',
		lbl_successful_updated: '',
		lbl_extracao_geral: '',
		lbl_essa_extracao_pode_levar_segundos: '',
		lbl_geral_exportar: '',
		lbl_geral_relatorio: '',
		lbl_projetos_nao_existe_item_parametros_pesquisa_requeridos: 'There are no items registered for the required search criteria',
	};

	@ViewChild('loadingMesoContainer') loadingHtmlElement: ElementRef;
	@ViewChild('viewColumnModal') viewColumnModal: ModalComponent;
	@ViewChild('exportRequestModal') exportRequestModal: ModalComponent;

	constructor() {}

	isLoadingAccordionData = false;

	isLoadingAllStatus = true;
	isLoadingSearch = true;
	isLoadingAvailableViewItems = true;
	isLoadingBehalfOf = false;
	isSavingRequestViewColumn = false;

	getAccordionRequestReq: Subscription;

	showColumnSelectionPanel = false;

	isAnalystView = localStorage.getItem('sessionStatus') === '1';

	editingAccordionTransition = false;
	isEditingAccordionOptions = false;

	isLoadingAvailableAccordions = true;
	isLoadingAccordionLength: accordionType[] = [];
	accordionSubscriptions: { [k: string]: Subscription } = {};
	accordionTimer: Timer;
	accordionRemainingUpdatePercentage = 100;
	// 'outOfOffice', 'basic', 'task', 'custom', 'group'
	accordionOrder: accordionGroupInterface[] = [
		{
			id: 'outOfOffice',
			label: 'lbl_responsabilidade_delegada',
			hidden: false,
			accordionArr: [],
			tip: 'lbl_ausencia_temporaria_delegada',
			firstLoad: true,
		},
		{
			id: 'basic',
			label: 'lbl_geral_pendencias_pessoais',
			hidden: false,
			accordionArr: [],
			tip: 'lbl_ausencia_temporaria_delegada',
			firstLoad: true,
		},
		{
			id: 'task',
			label: 'lbl_chamado_tarefas',
			hidden: false,
			accordionArr: [],
			tip: 'lbl_chamado_tarefa_encaminhada_vc',
			firstLoad: true,
		},
		{
			id: 'custom',
			label: 'lbl_rep_custom_id_36',
			hidden: false,
			accordionArr: [],
			tip: 'lbl_lista_chamados_personalizada',
			firstLoad: true,
		},
		{
			id: 'group',
			label: 'lbl_geral_pendencias_grupo',
			hidden: false,
			accordionArr: [],
			tip: 'lbl_geral_pendencias_grupo_analista',
			firstLoad: true,
		},
		{
			id: 'groupExecution',
			label: 'Pendencias de tarefa de execução do grupo',
			hidden: false,
			accordionArr: [],
			tip: 'Pendencias de tarefa de execução do grupo',
			firstLoad: true,
		},
	];
	dragAccordion = {
		isDragging: false,
		draggingType: null,
		groupIndex: null,
		accordionIndex: null,
		dragName: null,
		dropIndex: null,
		position: { x: 0, y: 0 },
		dragScreenScrollTop: 0,
	};

	allStatus: statusInterface[] = [];
	allStatusAsLabel = {};

	selectedAccordion: accordionInterface;
	accordionSolutionArea: string;
	sortBy = 'id';
	sortDown = false;
	selectedPage = 1;
	itemsPerPage = 20;
	maxPages = 1;
	requestViewItems: genericFormI[] = [];
	requestViewItemsOptions: genericFormI[] = [];
	requestViewItemsOptionsMemory: genericFormI[] = [];
	requestViewItemsOptionsDictionary = {};
	requestViewHeaders: () => mspTableHeaderI[] = () => {
		return this.requestViewItemsOptions[0].values.map((item) => {
			const mspTableHeader: mspTableHeaderI = {
				colType: this.formatInputType(item.inputType),
				ellipsis: false,
				nowrap: true,
				name: item.name,
				value: this.labels[item.label] ? this.labels[item.label] : item.label,
			};

			return mspTableHeader;
		});
	};
	formatInputType(type: genericFormI['inputType']): mspTableHeaderI['colType'] {
		if (type === 'string') return 'text';
		if (type === 'date') return 'date';
		if (type === 'select-iac' || type === 'select') return 'multi-select';
		return 'text';
	}
	onLineClick: (line: accordionInterface['request'][number]) => void = (line) => {
		if (!line.id) return;
		window.open('/request/' + line.id, '_blank');
	};

	satisfactionId = '';
	kbId = '';
	auxEscalationLevel = '';
	showForm = false;
	showRelatedCis = false;

	hideMainCol = false;
	secondColView = 'not-chosen';

	ghostResizeBar = {
		mouseDown: false,
		startX: null,
		mainCol: 40,
		subCol: 60,
	};

	searchHeader: mspTableHeaderI[] = [
		{ name: 'id', value: 'lbl_cmdb_id', colType: 'text' },
		{ name: 'identification', value: 'lbl_geral_identificacao', colType: 'text' },
		{ name: 'type', value: 'lbl_asset_tipo_ci', colType: 'text' },
		{ name: 'status', value: 'lbl_geral_status', colType: 'text' },
		{ name: 'active', value: 'lbl_geral_ativo', colType: 'text' },
	];

	searchHeaderRequest: mspTableHeaderI[] = [
		{ name: 'id', value: 'ID', colType: 'text' },
		{ name: 'summary', value: 'lbl_geral_summary', colType: 'text' },
		{ name: 'solution_area', value: 'lbl_geral_grupo', colType: 'text' },
		{ name: 'scope', value: 'lbl_geral_competencia', colType: 'text' },
		{ name: 'category', value: 'lbl_geral_natureza', colType: 'text' },
		{ name: 'topic', value: 'lbl_geral_topico', colType: 'text' },
	];

	taskExecutionHeaders: mspTableHeaderI[] = [
		{ name: 'id', value: 'lbl_chamado_id', colType: 'text', nowrap: true },
		{ name: 'solution_area', value: 'lbl_grupo', colType: 'text', nowrap: true },
		{ name: 'task', value: 'lbl_chamado_tarefa', colType: 'text', nowrap: true },
		{ name: 'status', value: 'lbl_geral_status', colType: 'text', nowrap: true },
		{ name: 'analyst', value: 'lbl_geral_analistas', colType: 'text', nowrap: true },
		{ name: 'description', value: 'lbl_geral_summary', colType: 'text', nowrap: true },
	];

	isSearchOpen = true;
	selectedOption = '';
	selectedField = '';
	typeTable = '';
	filterSelected = '';
	fieldOptions: searchRequestsInterface[] = [];
	filteredOptions: any[] = [];
	filteredOptionsIAC: iacOptionInterface[] = [];
	valueColumn = '';
	searchRequestsList: any[] = [];
	selectedPageSearch = 1;
	startDate: Date | null = null;
	endDate: Date | null = null;
	isDatePickerOpen = false;
	totalLengthSearch = '';
	@ViewChild(DateRangePickerComponent) datePicker!: DateRangePickerComponent;

	ngOnInit(): void {
		if (window.location.pathname.toLowerCase().includes('/request/kb')) {
			this.secondColView = 'kb';
		}

		this.labels = computed(() => this.LabelsService.labels())();

		this.HomePageService.getAllStatus().subscribe((allStatus) => {
			this.allStatus = allStatus;
			for (const status of this.allStatus) {
				this.allStatusAsLabel[status.status] = status.label;
			}
			this.isLoadingAllStatus = false;
		});

		this.HomePageService.getRequestFieldOptions().subscribe({
			next: (data: searchRequestsInterface[]) => {
				this.filteredOptionsIAC = [];
				this.fieldOptions = data;
				for (const option of this.fieldOptions) {
					const newIAC: iacOptionInterface = {
						name: option.column,
						value: option.column,
					};
					this.filteredOptionsIAC.push(newIAC);
				}
			},
			error: (error) => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_erro_0113);
				console.error('Erro for search options:', error);
			},
			complete: () => {},
		});

		this.getAccordionOrder();
		this.setupAccordionTimer();
		Notification.requestPermission().then((perm) => {
			console.log('Permission status updated:', perm);
		});
	}

	setupAccordionTimer(): void {
		const minutes = 1;
		const minutesInMs = minutes * 60 * 1000;

		this.getAllAccordion();
		if (this.accordionTimer) this.accordionTimer.stop();
		this.accordionTimer = new Timer(
			minutesInMs,
			(remainingTime) => {
				this.accordionRemainingUpdatePercentage = (remainingTime / minutesInMs) * 100;
			},
			() => {
				this.accordionTimer.reset();
				if (this.profileSignal.requestUpdateIntervalOn()) {
					this.getAllAccordion();
				}
			}
		);
		this.accordionTimer.start();
	}

	getAllAccordion(): void {
		const accordionTypes: accordionType[] = ['outOfOffice', 'basic', 'group', 'groupExecution', 'custom', 'task'];

		for (const accordionType of accordionTypes) {
			this.getAccordionByType(accordionType);
		}
	}

	getAccordionOrder(): void {
		this.HomePageService.getAccordionOrder().subscribe((accordionOrderRes) => {
			const accordionGroupOrderKeyArray = accordionOrderRes.map((ago) => {
				return ago.group_name;
			});
			this.accordionOrder.sort((a, b) => {
				if (a.id === 'groupExecution') return 1;
				if (b.id === 'groupExecution') return -1;
				return accordionGroupOrderKeyArray.indexOf(a.id) - accordionGroupOrderKeyArray.indexOf(b.id);
			});

			for (const [groupIndex, accordionGroupOrder] of accordionOrderRes.entries()) {
				const findAccordionGroup = this.accordionOrder.find((accordion) => {
					return accordion.id == accordionGroupOrder.group_name;
				});
				if (findAccordionGroup == undefined) continue;
				findAccordionGroup.hidden = accordionGroupOrder.group_hidden;

				//Handling accordion inside the group
				const accordionOrderKeyArray = accordionGroupOrder.accordion.map((ao) => {
					return ao.accordion_name;
				});
				this.accordionOrder[groupIndex].accordionArr.sort(
					(a, b) => accordionOrderKeyArray.indexOf(a.id) - accordionOrderKeyArray.indexOf(b.id)
				);
				for (let accordionIndex = 0; accordionIndex < accordionGroupOrder.accordion.length; accordionIndex++) {
					const accordionOrder = accordionGroupOrder.accordion[accordionIndex];
					const findAccordion = this.accordionOrder[groupIndex].accordionArr.find((accordion) => {
						return accordion.id == accordionOrder.accordion_name;
					});
					if (findAccordion == undefined) continue;
					findAccordion.hidden = accordionOrder.accordion_hidden;
				}
			}

			const groupIndex = this.accordionOrder.findIndex((accordion) => accordion.id === 'group');
			const groupExecutionIndex = this.accordionOrder.findIndex((accordion) => accordion.id === 'groupExecution');
			if (groupIndex >= 0 && groupExecutionIndex >= 0 && groupExecutionIndex !== groupIndex + 1) {
				const groupExecutionAccordion = this.accordionOrder.splice(groupExecutionIndex, 1)[0];
				this.accordionOrder.splice(groupIndex + 1, 0, groupExecutionAccordion);
			}

			this.checkSelectedRoute();
			this.isLoadingAvailableAccordions = false;
		});
	}

	getAccordionByType(type: accordionType): void {
		if (!this.isLoadingAccordionLength.includes(type)) this.isLoadingAccordionLength.push(type);

		if (this.accordionSubscriptions[type]) this.accordionSubscriptions[type].unsubscribe();

		this.accordionSubscriptions[type] = this.HomePageService.getAvailableAccordion(type).subscribe({
			next: (accordionData) => {
				const accordion = this.accordionOrder.find((accordion) => {
					return accordion.id == type;
				});
				const oldAccordion = JSON.parse(JSON.stringify(accordion)) as accordionGroupInterface;
				if (accordion) accordion.accordionArr = accordionData;
				this.checkAccordionChanges(oldAccordion, accordion, type);

				if (type == 'basic') {
					for (const index in accordionData) {
						const accordion = accordionData[index];
						if (accordion.id === 'satisfaction' && accordion.request.length > 0) {
							this.NotificationService.setNotificationMessage(this.labels.lbl_avaliacoes_pendentes_request);
							break;
						}
					}
				}

				this.isLoadingAccordionLength.splice(this.isLoadingAccordionLength.indexOf(type), 1);
				accordion.firstLoad = false;
			},
		});
	}

	checkAccordionChanges(oldAccordionInfo: accordionGroupInterface, newAccordionInfo: accordionGroupInterface, type: accordionType): void {
		const oldAccordionCounts = {};
		for (const accordion of oldAccordionInfo.accordionArr) oldAccordionCounts[accordion.id] = accordion.accordionLength;

		const newAccordionCounts = {};
		for (const accordion of newAccordionInfo.accordionArr) newAccordionCounts[accordion.id] = accordion.accordionLength;

		let changed = false;

		for (const accordionId of Object.keys(newAccordionCounts)) {
			if (oldAccordionCounts[accordionId] != undefined && newAccordionCounts[accordionId] > oldAccordionCounts[accordionId]) {
				changed = true;
			}
		}

		if (oldAccordionInfo.firstLoad == true || !changed) return;
		this.NotificationService.setPushNotificationMessage(this.labels.lbl_chamado_voce_tem, {
			uniqueId: 'pushNotificationAccordionChangeCheck',
			url: '/request',
		});
		this.NotificationService.setNotificationMessage(this.labels.lbl_chamado_voce_tem, { uniqueId: 'accordionChangeCheck' });
	}

	sortColumn(sortBy: string) {
		if (this.sortBy == sortBy) {
			this.sortDown = !this.sortDown;
		} else {
			this.sortBy = sortBy;
			this.sortDown = true;
		}
	}

	getTaskType(accordionId: string): string {
		const taskTypes = {
			taskReview: 'Review',
			taskAuthorization: 'Authorization',
			taskExecution: 'Execution',
		};

		return taskTypes[accordionId] || accordionId;
	}

	getColumnHeaderSubscription: Subscription;
	getColumnHeaders(accordionId?: string): void {
		if (accordionId !== undefined && String(accordionId).startsWith('task')) return;

		if (this.getColumnHeaderSubscription) this.getColumnHeaderSubscription.unsubscribe();

		this.requestViewItemsOptions = [];
		this.isLoadingAvailableViewItems = true;
		this.getColumnHeaderSubscription = forkJoin([
			this.HomePageService.getAvailableRequestViewItems(this.accordionSolutionArea),
			this.MspTableService.getTableColumns('request', this.accordionSolutionArea),
		]).subscribe(([viewItems, columns]) => {
			const baseViewItems = new Set(['id', 'summary', 'status', 'open_date']);
			let selectViewItems = ['id', 'summary', 'status', 'open_date'];
			if (columns.length === 0) {
				selectViewItems.push('limit_date', 'enduser', 'solution_area');
			}
			selectViewItems = selectViewItems.concat(columns);
			for (const viewItem of selectViewItems) {
				const findItem = viewItems[0].items.find((item) => {
					return item.name == viewItem;
				});
				if (findItem != undefined && !viewItems[0].values.includes(findItem)) {
					if (baseViewItems.has(findItem.rawValues[0])) findItem.unchangeable = true;
					viewItems[0].values.push(findItem);
					viewItems[0].rawValues.push(findItem.values[0]);
				}
			}

			this.requestViewItemsOptions = viewItems;
			this.isLoadingAvailableViewItems = false;
		});
	}

	getSelectedAccordionData(selectedAccordion: accordionInterface, page: number): void {
		if (this.isEditingAccordionOptions) return;

		this.selectedAccordion = selectedAccordion;
		this.selectedPage = page;

		this.secondColView = 'loading';
		if (this.getAccordionRequestReq) this.getAccordionRequestReq.unsubscribe();

		this.isLoadingAccordionData = true;
		const accordionDataRequest = this.selectedAccordion.taskGroupExecution
			? this.HomePageService.getGroupExecutionData(
					this.selectedAccordion.id,
					this.sortBy,
					this.sortDown,
					this.selectedPage - 1,
					this.itemsPerPage
				)
			: this.selectedAccordion.type === 'task'
				? this.HomePageService.getAccordionTaskData(
						this.getTaskType(this.selectedAccordion.id),
						this.sortBy,
						this.sortDown,
						this.selectedPage - 1,
						this.itemsPerPage
					)
				: this.HomePageService.getAccordionData(
						this.selectedAccordion.type,
						this.selectedAccordion.id,
						this.sortBy,
						this.sortDown,
						this.selectedPage - 1,
						this.itemsPerPage
					);

		this.getAccordionRequestReq = accordionDataRequest.subscribe({
			next: (accordionData) => {
				if (this.selectedAccordion.taskGroupExecution) {
					accordionData = accordionData.map((task) => ({ ...task, summary: task.description }));
				}
				this.selectedAccordion[this.selectedAccordion.dataType] = accordionData;

				//First col icon
				this.selectedAccordion.request?.forEach((field, index) => {
					Object.keys(field).forEach((key) => {
						if (key !== 'icon' && key !== 'escalation_level' && field[key] === '') {
							field[key] = '[N/A]';
						}
					});

					if (field.vip) {
						this.selectedAccordion.request[index] = { ...field, icon: this.iconsForStatus.vip };
					}

					if (field.escalation_level !== '' && field.escalation_level !== '[N/A]') {
						this.auxEscalationLevel = this.iconsForStatus.escalation_level.replace('LEVEL', field.escalation_level);
						this.selectedAccordion.request[index] = { ...field, icon: this.auxEscalationLevel };
					}

					if (field.status == 'Waiting for Approval') {
						this.selectedAccordion.request[index] = { ...field, icon: this.iconsForStatus[field.status] };
					}
				});

				this.isLoadingAccordionData = false;
				this.secondColView = 'card-col';
			},
			error: () => {
				this.isLoadingAccordionData = false;
				this.secondColView = 'card-col';
			},
		});
	}

	rollAccordionOptionTransition(): void {
		this.editingAccordionTransition = true;
		setTimeout(() => {
			this.isEditingAccordionOptions = !this.isEditingAccordionOptions;
		}, 333);
		setTimeout(() => {
			this.editingAccordionTransition = false;
		}, 666);
	}

	hideAccordion(e: Event, groupIndex: number, accordionIndex?: number): void {
		e.stopPropagation();
		if (accordionIndex)
			this.accordionOrder[groupIndex].accordionArr[accordionIndex].hidden =
				!this.accordionOrder[groupIndex].accordionArr[accordionIndex].hidden;
		else this.accordionOrder[groupIndex].hidden = !this.accordionOrder[groupIndex].hidden;
	}

	startDragAccordion(
		dragAreaDOM: HTMLElement,
		me: MouseEvent,
		type: 'group' | 'accordion',
		groupIndex: number,
		accordionIndex?: number
	): void {
		const rect = dragAreaDOM.getBoundingClientRect();
		this.dragAccordion.position.x = me.clientX - rect.left + 4 + dragAreaDOM.scrollLeft;
		this.dragAccordion.position.y = me.clientY - rect.top + 4 + dragAreaDOM.scrollTop;
		this.dragAccordion.draggingType = type;
		this.dragAccordion.groupIndex = groupIndex;
		this.dragAccordion.accordionIndex = accordionIndex;
		if (type == 'group')
			this.dragAccordion.dragName = this.labels[this.accordionOrder[groupIndex].label]
				? this.labels[this.accordionOrder[groupIndex].label]
				: this.accordionOrder[groupIndex].label;
		if (type == 'accordion')
			this.dragAccordion.dragName = this.labels[this.accordionOrder[groupIndex].accordionArr[accordionIndex].name]
				? this.labels[this.accordionOrder[groupIndex].accordionArr[accordionIndex].name]
				: this.accordionOrder[groupIndex].accordionArr[accordionIndex].name;
		this.dragAccordion.isDragging = true;
	}

	endDragAccordion(): void {
		this.dragAccordion.position.x = 0;
		this.dragAccordion.position.y = 0;
		this.dragAccordion.draggingType = null;
		this.dragAccordion.groupIndex = null;
		this.dragAccordion.accordionIndex = null;
		this.dragAccordion.dragName = null;
		this.dragAccordion.isDragging = false;
	}

	setDragPosition(dragAreaDOM: HTMLElement, me: MouseEvent): void {
		const rect = dragAreaDOM.getBoundingClientRect();
		this.dragAccordion.position.x = me.clientX - rect.left + 4 + dragAreaDOM.scrollLeft;
		this.dragAccordion.position.y = me.clientY - rect.top + 4 + dragAreaDOM.scrollTop;
	}

	dropAccordion(groupIndex: number, accordionIndex?: number): void {
		if (this.dragAccordion.draggingType == 'group') {
			const holdGroup = this.accordionOrder[groupIndex];
			this.accordionOrder[groupIndex] = this.accordionOrder[this.dragAccordion.groupIndex];
			this.accordionOrder[this.dragAccordion.groupIndex] = holdGroup;
		}
		if (this.dragAccordion.draggingType == 'accordion') {
			const holdAccordion = this.accordionOrder[groupIndex].accordionArr[accordionIndex];
			this.accordionOrder[groupIndex].accordionArr[accordionIndex] =
				this.accordionOrder[groupIndex].accordionArr[this.dragAccordion.accordionIndex];
			this.accordionOrder[groupIndex].accordionArr[this.dragAccordion.accordionIndex] = holdAccordion;
		}
		this.endDragAccordion();
	}

	saveAccordionOptions(): void {
		if (this.isEditingAccordionOptions == false) return;
		const body: accordionGroupOrder[] = [];
		for (const [group_index, accordion_group] of this.accordionOrder.entries()) {
			const temporary_accordion_group = {
				group_name: accordion_group.id,
				group_hidden: accordion_group.hidden,
				group_order: group_index,
				accordion: [],
			};
			for (const [accordion_index, accordion] of accordion_group.accordionArr.entries()) {
				const temporary_accordion = {
					accordion_name: accordion.id,
					accordion_hidden: accordion.hidden,
					accordion_order: accordion_index,
				};
				temporary_accordion_group.accordion.push(temporary_accordion);
			}
			body.push(temporary_accordion_group);
		}

		this.HomePageService.updateAccordionOrder(body).subscribe({
			// next: () => { this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated) }
		});
	}

	handleCellValue(cellValue: any, cellHeaderInputType: genericFormI['inputType']): string {
		cellValue = this.separateCellMarkupFromValue(cellValue, 'cellValue');
		if (cellHeaderInputType == 'date') return this.DateService.formatDate(cellValue);
		else {
			return this.labels[cellValue] != undefined && this.labels[cellValue] != '' ? this.labels[cellValue] : cellValue;
		}
	}

	handleCellMarkup(cellValue: any): string {
		cellValue = this.separateCellMarkupFromValue(cellValue, 'cellMarkup');

		return cellValue;
	}

	separateCellMarkupFromValue(cellText: any, side: 'cellMarkup' | 'cellValue'): string {
		const markupRegex = /§([^§]+)§([^§]+)/;
		if (cellText == undefined || cellText == '') return '';
		cellText = cellText.toString();
		const sCellText = cellText.split('§');
		if (side == 'cellValue') return sCellText.at(-1);
		if (side == 'cellMarkup' && markupRegex.test(cellText)) {
			const markupArray = sCellText[1].split(';');
			let markupStyle = '{';
			markupArray.forEach((markup: string, index: number) => {
				const markupValue = markup.split(':')[markup.split(':').length - 1];
				if (markup.startsWith('fc')) {
					const cssVariablePattern = /^var\(--[\w-]+\)$/;
					const hexColorPattern = /^#([\dA-Fa-f]{3}|[\dA-Fa-f]{6})$/;
					if (cssVariablePattern.test(markupValue) || hexColorPattern.test(markupValue)) {
						markupStyle += `"color":"${markupValue}"`;
						if (index != markupArray.length - 1) markupStyle += ', ';
					}
				}

				if (markup.startsWith('fs')) {
					if (markupValue == 'i') {
						markupStyle += `"font-style": "italic"`;
						if (index != markupArray.length - 1) markupStyle += ', ';
					}
					if (markupValue == 'b') {
						markupStyle += `"font-weight": "bold"`;
						if (index != markupArray.length - 1) markupStyle += ', ';
					}
				}
			});
			markupStyle += '}';
			return JSON.parse(markupStyle);
		}

		return null;
	}

	enterBehalfOfMode(e: Event, userEmail: string): void {
		if (this.isLoadingBehalfOf) return;
		this.isLoadingBehalfOf = true;
		this.BehalfOfService.enterBehalfOfMode(userEmail).subscribe((res) => {
			location.reload();
		});
		e.stopPropagation();
	}

	// setRequestCardView(viewType : string): void {
	//   this.requestCardViewType = viewType;
	// }

	setSatisfaction(satisfactionId: string, id_enduser): void {
		if (id_enduser != this.ProfileService.userData().id) {
			this.Router.navigateByUrl('/request/' + satisfactionId);
			return;
		}

		this.satisfactionId = satisfactionId;
		this.secondColView = 'satisfaction';
	}

	goToRequest(idRequest: string): void {
		this.Router.navigateByUrl('/request/' + idRequest);
	}

	resetRequestOpening(): void {
		this.secondColView = 'not-chosen';
		setTimeout(() => {
			this.secondColView = 'selfservice';
			window.history.replaceState({}, '', '/request?view=selfservice');
		}, 10);
	}

	handleGhostResizeBar(e: MouseEvent): void {
		if (!this.ghostResizeBar.mouseDown) return;
		this.ghostResizeBar.subCol = 100 - (e.pageX / (window.innerWidth + 64)) * 100;
		this.ghostResizeBar.mainCol = (e.pageX / (window.innerWidth + 64)) * 100;
	}

	handleNavigationPage(): void {
		window.history.replaceState(
			{},
			'',
			`/request?view=accordion&name=${this.selectedAccordion.id?.toString().replaceAll(' ', '_')}&p=${this.selectedPage}`
		);
	}

	checkSelectedRoute(): void {
		this.ActivatedRoute.queryParams.subscribe((parameter) => {
			switch (parameter.view) {
				case 'selfservice': {
					this.secondColView = 'selfservice';
					break;
				}
				case 'accordion': {
					if (!parameter.name) {
						window.history.replaceState({}, '', `/request`);
						break;
					}
				}

				//   let selectedAccordion: accordionInterface = undefined;
				//   for(let i = 0; i < this.basicAccordionArr.length; i++) {
				//     let accordion = this.basicAccordionArr[i];
				//     if(accordion.id != param.name) continue;
				//     this.setCardCol(this.basicAccordionArr, i.toString());
				//     if(param.p && param.p > 0 && param.p <= this.maxPages) this.selectedPage = param.p;
				//     break;
				//   }
				//   for(let i = 0; i < this.groupAccordion.length; i++) {
				//     let accordion = this.groupAccordion[i];
				//     if(accordion.id != param.name) continue;
				//     this.setCardCol(this.groupAccordion, i.toString());
				//     if(param.p && param.p > 0 && param.p <= this.maxPages) this.selectedPage = param.p;
				//     break;
				//   }
				//   for(let i = 0; i < this.customAccordion.length; i++) {
				//     let accordion = this.customAccordion[i];
				//     if(accordion.id != param.name) continue;
				//     this.setCardCol(this.customAccordion, i.toString());
				//     if(param.p && param.p > 0 && param.p <= this.maxPages) this.selectedPage = param.p;
				//     break;
				//   }
				//   for(let i = 0; i < this.taskAccordion.length; i++) {
				//     let accordion = this.taskAccordion[i];
				//     if(accordion.id != param.name) continue;
				//     this.setCardCol(this.taskAccordion, i.toString());
				//     if(param.p && param.p > 0 && param.p <= this.maxPages) this.selectedPage = param.p;
				//     break;
				//   }
				default: {
					window.history.replaceState({}, '', `/request`);
				}
			}
		});
	}

	isElementOverflown(element: HTMLElement) {
		return element.scrollWidth > element.clientWidth;
	}

	toogleDivCustom() {
		this.showForm = !this.showForm;
		this.showForm === true ? (this.secondColView = 'custom') : (this.secondColView = 'not-chosen');
	}

	openRequestByCi(item: any): void {
		this.Router.navigateByUrl('/request?view=selfservice&idCmdb=' + item.id);
	}

	toogleDivCmdb() {
		this.showRelatedCis = true;
		this.showRelatedCis === true ? (this.secondColView = 'cmdb') : (this.secondColView = 'not-chosen');
		this.cdr.detectChanges();
	}

	formatNumberWithLeadingZeros(value: number): string {
		return value.toString().padStart(3, '0');
	}

	toggleMainCol(): void {
		this.hideMainCol = !this.hideMainCol;
		if (this.hideMainCol == true) {
			this.ghostResizeBar.mainCol = 0;
			this.ghostResizeBar.subCol = 100;
		} else {
			this.ghostResizeBar.mainCol = 40;
			this.ghostResizeBar.subCol = 60;
		}
	}

	selectOption(option: string) {
		this.filterSelected = option;

		const fieldFound = this.fieldOptions.find((field) => field.column === this.filterSelected);

		if (fieldFound && fieldFound.type_table === 'standard') {
			this.valueColumn = fieldFound.column_name;
			this.typeTable = fieldFound.type_table;
		} else if (fieldFound) {
			this.valueColumn = fieldFound.id;
			this.typeTable = fieldFound.type_table;
		}

		if (fieldFound) {
			this.selectedField = fieldFound.field_type;

			if (this.selectedField === 'Select') {
				this.HomePageService.getRequestFieldOptionsSelect({
					id: fieldFound.id ? fieldFound.id : '',
					column_name: fieldFound.column_name,
					type_table: fieldFound.type_table,
				}).subscribe({
					next: (data: any[]) => {
						this.filteredOptions = data;
					},
					error: (error) => {
						this.NotificationService.setNotificationMessage(this.labels.lbl_erro_0113);
						console.error('Erro for search options:', error);
					},
					complete: () => {},
				});
			}
		} else {
			this.filteredOptions = [];
		}

		if (option === '') {
			this.cleanSearch();
		} else {
			this.selectedOption = '';
		}
	}

	searchRequest() {
		this.isLoadingSearch = true;
		this.HomePageService.getSearchRequests({
			search: this.selectedOption,
			column: this.valueColumn,
			typeTable: this.typeTable,
			page: this.selectedPageSearch - 1,
			itemsPerPage: this.itemsPerPage,
		}).subscribe({
			next: (data) => {
				this.searchRequestsList = data;
				if (this.searchRequestsList.length > 0) {
					this.totalLengthSearch = data[0]?.total.toString();
				}
			},
			error: (error) => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_erro_0113);
				console.error('Erro for search:', error);
			},
			complete: () => {
				this.secondColView = 'search-col';
				if (this.searchRequestsList.length > 0) {
					this.isLoadingSearch = false;
				} else {
					this.searchRequestsList = [];
					this.isLoadingSearch = true;
					this.NotificationService.setNotificationMessage(
						this.labels.lbl_projetos_nao_existe_item_parametros_pesquisa_requeridos
					);
				}
			},
		});
	}

	onPageChange(page: number) {
		this.selectedPageSearch = page;
		this.searchRequest();
	}

	openRequest(item: any): void {
		window.open(this.Router.createUrlTree(['/request', item.id]).toString(), '_blank');
	}

	cleanSearch(): void {
		this.selectedField = '';
		this.selectedOption = '';
		this.filterSelected = '';
		this.valueColumn = '';
		this.filteredOptions = [];
	}

	onDatesConfirmed(dateRange: string[]) {
		this.selectedOption = dateRange
			.map((date) => {
				const newDate = new Date(date);
				return `${String(newDate.getDate()).padStart(2, '0')}/${String(newDate.getMonth() + 1).padStart(2, '0')}/${newDate.getFullYear()}`;
			})
			.join(' - ');
		this.isDatePickerOpen = false;
	}

	saveRequestViewColumns(): void {
		if (this.isSavingRequestViewColumn) return;
		const valueArray = [];
		this.isSavingRequestViewColumn = true;
		for (const value of this.requestViewItemsOptions[0].values) {
			valueArray.push(value.values[0]);
		}
		this.MspTableService.setTableColumns('request', valueArray, this.accordionSolutionArea)
			.subscribe((res) => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
				this.viewColumnModal.closeModal();
			})
			.add(() => {
				this.isSavingRequestViewColumn = false;
			});
	}

	exportRequestTable(): void {
		const idNotificaton = this.LoadingNotificationService.setNotificationMessage(
			`${this.labels.lbl_geral_relatorio} - ${this.labels.lbl_chamado}`,
			'loading',
			'faFileAlt'
		);
		this.getAccordionRequestReq = this.HomePageService.getAccordionData(
			this.selectedAccordion.type,
			this.selectedAccordion.id,
			this.sortBy,
			this.sortDown
		).subscribe({
			next: (accordionData) => {
				const excelData = [];
				const line = [];
				for (const viewItem of this.requestViewItemsOptions[0].values) {
					const viewItemLabel = this.labels[viewItem.label] ? this.labels[viewItem.label] : viewItem.label;
					line.push(viewItemLabel);
				}
				for (const requestData of accordionData) {
					const line = [];
					for (const userColumn of this.requestViewItemsOptions[0].rawValues) {
						line.push(requestData[userColumn]);
					}
					excelData.push(line);
				}

				this.ExcelService.exportAsExcelFile(excelData, this.labels.lbl_chamado);
				this.LoadingNotificationService.updateNotificationStatus(idNotificaton, 'success');
			},
			error: () => {
				this.LoadingNotificationService.updateNotificationStatus(idNotificaton, 'error');
			},
		});
		this.exportRequestModal.closeModal();
	}
}
